import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "fourWheelDriveFilled"
const FourWheelDriveFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M11.25 18V6C11.25 5.586 11.586 5.25 12 5.25S12.75 5.586 12.75 6V18C12.75 18.414 12.414 18.75 12 18.75S11.25 18.414 11.25 18" />
          <path d="M15.75 4.5C16.164 4.5 16.5 4.836 16.5 5.25S16.164 6 15.75 6H8.25C7.836 6 7.5 5.664 7.5 5.25S7.836 4.5 8.25 4.5zM15.75 18C16.164 18 16.5 18.336 16.5 18.75S16.164 19.5 15.75 19.5H8.25C7.836 19.5 7.5 19.164 7.5 18.75S7.836 18 8.25 18zM4.5 3C4.5 2.586 4.836 2.25 5.25 2.25H6.75C7.164 2.25 7.5 2.586 7.5 3V7.5C7.5 7.914 7.164 8.25 6.75 8.25H5.25C4.836 8.25 4.5 7.914 4.5 7.5z" />
          <path d="M5.25 3V7.5H6.75V3zM8.25 7.5C8.25 8.328 7.578 9 6.75 9H5.25C4.422 9 3.75 8.328 3.75 7.5V3C3.75 2.172 4.422 1.5 5.25 1.5H6.75C7.578 1.5 8.25 2.172 8.25 3zM4.5 16.5C4.5 16.086 4.836 15.75 5.25 15.75H6.75C7.164 15.75 7.5 16.086 7.5 16.5V21C7.5 21.414 7.164 21.75 6.75 21.75H5.25C4.836 21.75 4.5 21.414 4.5 21z" />
          <path d="M5.25 16.5V21H6.75V16.5zM8.25 21C8.25 21.828 7.578 22.5 6.75 22.5H5.25C4.422 22.5 3.75 21.828 3.75 21V16.5C3.75 15.672 4.422 15 5.25 15H6.75C7.578 15 8.25 15.672 8.25 16.5zM16.5 3C16.5 2.586 16.836 2.25 17.25 2.25H18.75C19.164 2.25 19.5 2.586 19.5 3V7.5C19.5 7.914 19.164 8.25 18.75 8.25H17.25C16.836 8.25 16.5 7.914 16.5 7.5z" />
          <path d="M17.25 3V7.5H18.75V3zM20.25 7.5C20.25 8.328 19.578 9 18.75 9H17.25C16.422 9 15.75 8.328 15.75 7.5V3C15.75 2.172 16.422 1.5 17.25 1.5H18.75C19.578 1.5 20.25 2.172 20.25 3zM16.5 16.5C16.5 16.086 16.836 15.75 17.25 15.75H18.75C19.164 15.75 19.5 16.086 19.5 16.5V21C19.5 21.414 19.164 21.75 18.75 21.75H17.25C16.836 21.75 16.5 21.414 16.5 21z" />
          <path d="M17.25 16.5V21H18.75V16.5zM20.25 21C20.25 21.828 19.578 22.5 18.75 22.5H17.25C16.422 22.5 15.75 21.828 15.75 21V16.5C15.75 15.672 16.422 15 17.25 15H18.75C19.578 15 20.25 15.672 20.25 16.5zM13.125 12C13.125 12.621 12.621 13.125 12 13.125S10.875 12.621 10.875 12 11.379 10.875 12 10.875 13.125 11.379 13.125 12" />
          <path d="M13.125 12C13.125 11.379 12.621 10.875 12 10.875S10.875 11.379 10.875 12 11.379 13.125 12 13.125 13.125 12.621 13.125 12M14.625 12C14.625 13.45 13.45 14.625 12 14.625S9.375 13.45 9.375 12 10.55 9.375 12 9.375 14.625 10.55 14.625 12" />
        </svg>
      }
    </span>
  )
}
export default FourWheelDriveFilledIcon
